module.exports = __webpack_public_path__ + "img/table-pin-red.38cddc3d.svg";